export function isPermissionDisabled(permissionType, permission) {
  return permissionType === 'conditionallyRequired' && permission.isOnInstalls;
}